import { JetView } from 'webix-jet'; // Importing JetView for creating a view
import PlayersView from '../players'; // Importing PlayersView component
import FilterCasinoReport from '../customers/reports/casinoReport/filterCasinoReport'; // Importing filter component for casino report
import TableCasinoReport from '../customers/reports/casinoReport/tableCasinoReport'; // Importing table component for casino report
import DetailsCasinoReport from '../customers/reports/casinoReport/detailsCasinoReport'; // Importing details component for casino report
import RecordCasinoReport from '../customers/reports/casinoReport/recordCasinoReport'; // Importing record component for casino report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the layout of the Casino Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Configuration for the right section of the layout
            type: 'wide',
            minWidth: 200,
            rows: [RecordCasinoReport, DetailsCasinoReport], // Rows containing record and details components
        };
        const toolbar = {
            // Configuration for the toolbar
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Columns in the toolbar
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching
                },
            ],
        };
        const left = {
            // Configuration for the left section of the layout
            height: screen.width < 500 ? 500 : 0, // Responsive height based on screen width
            rows: [
                // Rows in the left section
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        // Elements in the toolbar
                        {
                            view: 'label', // Label element
                            label: _('Reporte de Casino'), // Localized label text
                            width: 300, // Width of the label
                        },
                    ],
                },
                FilterCasinoReport, // Filter component
                TableCasinoReport, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Form view
            rows: [
                // Rows in the main layout
                {
                    responsive: 'a5', // Responsive behavior
                    type: 'wide', // Type of the row
                    cols: [left, right], // Columns containing left and right sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
